import React, {useContext} from 'react';
import {GlobalInfo} from "./context";
import {numberWithCommas, shortNumber} from "./util";
import {globalSettings} from "./config";

export function AuditPage() {
  let context = useContext(GlobalInfo);

    let totalIskBalance = 0;
    let totalPandaBalance = 0;
    context.users.forEach((user) => {
      totalIskBalance += (user.balanceIsk || 0);
      totalPandaBalance += (user.balancePanda || 0);
    });

    let totalRequests = 0;
    context.materials.forEach((material) => {
      totalRequests += ((material.multiplier || 50) / 100 * Math.max(0, (material.totalTargetInventory || 0) - (material.totalInventory || 0)) * (material.price || 0)) * 0.8;
    });

    let inventoryByLocation = {};
    Object.keys(globalSettings.locations).forEach((location) => {

    });

    let totalInventory = 0;
    context.materials.forEach((material) => {
      if (material.type === "ore") {
        return;
      }
      totalInventory += ((material.price || 0) * (material.totalInventory || 0));

      for (const [location, amount] of Object.entries(material.inventory)) {
        if (!amount) {
          continue;
        }
        if (!inventoryByLocation[location]) {
          inventoryByLocation[location] = {
            mineral: 0,
            planetary: 0,
            structure: 0,
            debris: 0,
            datacore: 0,
            other: 0,
          }
        }
        if (material.type === "mineral") {
          inventoryByLocation[location]["mineral"] += ((material.price || 0) * amount)
        } else if (material.type === "planetary") {
          if(globalSettings.structureMaterials.indexOf(material.name) !== -1) {
            inventoryByLocation[location]["structure"] += ((material.price || 0) * amount)
          } else {
            inventoryByLocation[location]["planetary"] += ((material.price || 0) * amount)
          }
        } else if (material.type === "debris") {
          inventoryByLocation[location]["debris"] += ((material.price || 0) * amount)
        } else if (material.type === "datacore") {
          inventoryByLocation[location]["datacore"] += ((material.price || 0) * amount)
        } else  {
          inventoryByLocation[location]["other"] += ((material.price || 0) * amount)
        }
      }
    });

  return <div className={"container"}>
      <div>
        <p>Total balance: {numberWithCommas(totalIskBalance)} ISK, {numberWithCommas(totalPandaBalance)} {"\u{1F43C}"}</p>
        <p>Total requests: {numberWithCommas(totalRequests)} ISK</p>
        <p>Total inventory: {numberWithCommas(totalInventory)} ISK</p>
      </div>
      <table className={"table table-striped"}>
        <thead>
            <tr>
              <th>Location</th><th>Mineral</th><th>Ship PI</th><th>Structure PI</th><th>Debris</th><th>Datacore</th>
            </tr>
        </thead>
        <tbody>
        {Object.keys(inventoryByLocation).map((location) => {
          let data = inventoryByLocation[location];
          return <tr>
            <td>{location}</td>
            <td>{shortNumber(data.mineral)} ISK</td>
            <td>{shortNumber(data.planetary)} ISK</td>
            <td>{shortNumber(data.structure)} ISK</td>
            <td>{shortNumber(data.debris)} ISK</td>
            <td>{shortNumber(data.datacore)} ISK</td>
          </tr>
        })}
        </tbody>
      </table>
  </div>
}